import { useUiStore } from '@/store/uiStore';

export type Theme = 'light' | 'dark';

/**
 * Light wrapper over the UI store so screens can do
 * `const { theme, toggle } = useTheme()`.
 * The class on <html> is updated in App.tsx whenever `theme` changes.
 */
export function useTheme(): { theme: Theme; toggle: () => void; set: (t: Theme) => void } {
  const theme = useUiStore((s) => s.theme);
  const setTheme = useUiStore((s) => s.setTheme);
  return {
    theme,
    set: setTheme,
    toggle: () => setTheme(theme === 'dark' ? 'light' : 'dark'),
  };
}
